var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpbitLogo35A5B2A(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.7307 5.39365h-6.0705L49.4158 0h-5.3936l-5.8379 17.9788h11.2315c2.6017 0 4.9072-1.6709 5.7109-4.1457l1.4595-4.5264c.6134-1.9248-.8249-3.91305-2.8555-3.91305Zm-2.4958 3.78614-1.2057 3.74381c-.4019 1.2268-1.5441 2.0729-2.8555 2.0729H44.551l2.1363-6.59932h3.9765c.4018 0 .698.40188.5711.78261ZM63.2067 0l-1.1634 3.59577h5.3937L68.6003 0h-5.3936ZM57.3688 17.9788h5.3937l4.0822-12.58517h-5.3936L57.3688 17.9788ZM74.9458 8.39718h3.6381l.9729-3.00353h-3.638L77.6743 0h-5.3936l-4.5688 14.0658C67.0774 16.0118 68.5368 18 70.5674 18h5.9859l.973-3.0035h-3.8919c-.4019 0-.698-.4019-.5711-.7826l1.8825-5.81672Z",
    fill: "#023F97"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4193 6.28202 22.3205 0h-6.3243l-4.8648 14.9965H7.07025c-.40188 0-.698-.4019-.57109-.7826L11.1102 0H5.71655L1.14781 14.0658c-.634549 1.9459.82491 3.913 2.85546 3.913H15.552l4.0823-12.58515-3.215.88837ZM36.3654 0H23.9705l1.8191 6.28202-2.644-.88837-4.0822 12.58515h5.3936l1.946-5.9859h5.8378c2.6016 0 4.9072-1.6709 5.7109-4.14566l1.2691-3.9342C39.8554 1.98825 38.4171 0 36.3654 0Zm-2.4959 3.78613-1.0153 3.15159c-.4019 1.22679-1.5441 2.07286-2.8555 2.07286h-2.6228l1.946-5.9859h3.9765c.423-.02115.698.35957.5711.76145Z",
    fill: "#0062DF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpbitLogo35A5B2A);
export default __webpack_public_path__ + "static/media/upbit_logo.35a5b2a.35a5b2a9c6cbc7c16c6bfac1e293f239.svg";
export { ForwardRef as ReactComponent };